import { render, staticRenderFns } from "./form.md?vue&type=template&id=f3fba6c0"
import script from "./form.md?vue&type=script&lang=js"
export * from "./form.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports